import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type EpreuveFormValues = {
  name: string;
  year: Date;
  discipline: string;
  content: File;
};

export const epreuveValidationSchema = yup.object({
  name: yup
    .string()
    .required('Le nom est obligatoire.')
    .min(3, 'Le nom doit contenir au moins 3 caractères.')
    .max(100, 'Le nom ne peut pas dépasser 100 caractères.'),
  year: yup
    .date()
    .required('La date est obligatoire.')
    .typeError('Veuillez entrer une date valide.'),
  discipline: yup.string().required('La discipline est obligatoire.'),
  content: yup
    .mixed<File>()
    .required('Le fichier est obligatoire.')
    .test(
      'fileType',
      'Seuls les fichiers PNG, JPEG, JPG et MP3 sont autorisés.',
      (value) => {
        if (!value) return false;
        return ['image/jpeg', 'image/png', 'image/jpg', 'audio/mpeg'].includes(
          value.type,
        );
      },
    ),
});

export const useEpreuveForm = () => {
  const { register, handleSubmit, errors, setValue, reset } =
    useFormHandler<EpreuveFormValues>(epreuveValidationSchema);

  return { register, handleSubmit, errors, setValue, reset };
};
